import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, first, map } from 'rxjs';
import { NotificationService } from '../notifications/notification.service';
import { environment as env } from '../../../environments/environment';
import { AverageRate } from '../../data-models/average-rate.model';

@Injectable({
  providedIn: 'root'
})
export class LgvAverageRatesService {

    currentRates$ = new BehaviorSubject(null);
    dailyRates$ = new BehaviorSubject(null);
    hourlyRates$ = new BehaviorSubject(null);
    isLoadingRates$ = new BehaviorSubject(false);

    constructor(private http: HttpClient,
                private notificationSvc: NotificationService) {}

    get isProdorUAT(): boolean { return env.envName === 'PROD' || env.envName === 'UAT' }

    // Helper method to format timestamp
    private formatTimestamp(timestamp: string): string {
        return new Date(timestamp).toLocaleString('en-US');
    }

    fetchCurrentRates() {
        this.isLoadingRates$.next(true);
        this.http.get<AverageRate[]>(`${env.LgvApiBaseUrl}/public/pricing/history/current`)
            .pipe(
                first(),
                map(data => data.map(item => ({
                    ...item,
                    timestamp: this.formatTimestamp(item.timestamp)
                })))
            )
            .subscribe({
                next: (data) => {
                    this.currentRates$.next(data);
                    this.isLoadingRates$.next(false);
                },
                error: (error) => {
                    this.notificationSvc.error('Error fetching current rates.');
                    this.isLoadingRates$.next(false);
                }
            });
    }

    fetchDailyRates(startDate?: string, endDate?: string, product?: string) {
        this.isLoadingRates$.next(true);
        let params = {};
        if (startDate) {
            params = { ...params, startDate };
        }
        if (endDate) {
            params = { ...params, endDate };
        }
        if (product) {
            params = { ...params, product };
        }

        this.http.get<AverageRate[]>(`${env.LgvApiBaseUrl}/public/pricing/history/daily`, { params })
            .pipe(
                first(),
                map(data => data.map(item => ({
                    ...item,
                    timestamp: this.formatTimestamp(item.timestamp)
                })))
            )
            .subscribe({
                next: (data) => {
                    this.dailyRates$.next(data);
                    this.isLoadingRates$.next(false);
                },
                error: (error) => {
                    this.notificationSvc.error('Error fetching daily rates.');
                    this.isLoadingRates$.next(false);
                }
            });
    }

    fetchHourlyRates(product?: string) {
        this.isLoadingRates$.next(true);
        let params = {};
        if (product) {
            params = { ...params, product };
        }

        this.http.get<AverageRate[]>(`${env.LgvApiBaseUrl}/public/pricing/history/hourly`, { params })
            .pipe(
                first(),
                map(data => data.map(item => ({
                    ...item,
                    timestamp: this.formatTimestamp(item.timestamp)
                })))
            )
            .subscribe({
                next: (data) => {
                    this.hourlyRates$.next(data);
                    this.isLoadingRates$.next(false);
                },
                error: (error) => {
                    this.notificationSvc.error('Error fetching hourly rates.');
                    this.isLoadingRates$.next(false);
                }
            });
    }
}
